export const styles = {
  button: {
    fontFamily: '"Proxima Nova", sans-serif',
    lineHeight: '20px',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    width: '208px',
    cursor: 'pointer',
    textTransform: 'none',
    color: '#FFFFFF !important',
    fontSize: '16px',
    fontWeight: 700,
  },
  disabled: {
    backgroundColor: '#d0d0d0 !important',
  },
}
